"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DSSMY001 = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const react_redux_1 = require("react-redux");
const styled_components_1 = __importDefault(require("styled-components"));
const common_1 = require("../../../common");
const GlobalStateProvider_1 = require("../../../GlobalStateProvider");
const academy_1 = require("../../../server/academy");
const account_1 = require("../../base/account");
const classes_1 = require("../../base/classes");
const PLACEHOLDER_ACADEMY = { id: 'select', title: 'myAcademy.selectAcademyPlaceholder' };
const Wrap = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 24px;

	.user-info {
		display: flex;
		flex-direction: column;
		gap: 4px;

		.user-name {
			display: flex;
			align-items: flex-start;
			gap: 8px;
			font-size: 20px;
			font-weight: 700;
			color: var(--color-black, #101010);
		}

		.user-meta {
			display: flex;
			align-items: center;
			gap: 8px;
			font-size: 13px;
			color: var(--color-grey-6, #666);
			flex-wrap: wrap;

			.user-class,
			.user-academy {
				display: flex;
				align-items: center;
				gap: 4px;
			}

			.divider {
				color: var(--color-grey-c, #e6e8ed);
			}
		}
	}

	.content-box {
		border: 1px solid var(--color-grey-c, #e6e8ed);
		border-radius: 12px;
		padding: 32px;
		display: flex;
		flex-direction: column;
		gap: 24px;

		&.mobile {
			padding: 20px 16px;
		}
	}

	.guide-section {
		display: flex;
		align-items: flex-start;
		gap: 4px;
	}

	.info-icon {
		font-size: 18px;
		line-height: 1.2;
	}

	.guide-text {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		font-size: 14px;
		font-weight: 700;
		line-height: 1.6;
		white-space: pre-line;
	}

	.form-section {
		display: flex;
		flex-direction: column;
		gap: 8px;

		.section-label {
			font-size: 14px;
			font-weight: 600;
		}

		.section-guide {
			font-size: 12px;
			color: var(--color-grey-6, #666);
		}
	}

	.consent-section {
		display: flex;
		flex-direction: column;
		gap: 0;

		.consent-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 8px 0;
			flex-wrap: wrap;
			gap: 8px;

			.checkbox-item {
				display: flex;
				align-items: center;
				gap: 6px;
				font-size: 13px;
				color: var(--color-main, #e87722);
				cursor: pointer;

				label {
					cursor: pointer;
				}
			}

			.btn-detail {
				font-size: 12px;
				color: var(--color-grey-6, #666);
				background: none;
				border: 1px solid var(--color-grey-c, #e6e8ed);
				border-radius: 4px;
				padding: 4px 10px;
				cursor: pointer;
				display: flex;
				align-items: center;
				gap: 4px;
				margin-left: auto;
			}
		}

		.section-label {
			font-size: 14px;
			font-weight: 600;
			color: var(--color-black, #101010);
		}

		.consent-detail {
			background: var(--color-silver, #f3f4f8);
			border-radius: 8px;
			padding: 16px;
			font-size: 12px;
			color: var(--color-grey-6, #666);
			line-height: 1.8;
			display: flex;
			flex-direction: column;
			gap: 6px;
		}
	}

	.btn-area {
		display: flex;
		justify-content: flex-end;

		.button {
			min-width: 100px;
			height: 44px;
			border-radius: 8px;
			font-size: 14px;
			font-weight: 600;

			&.active {
				background: var(--color-black, #101010);
				color: var(--color-white, #fff);
			}

			&:not(.active) {
				background: var(--color-grey-c, #e6e8ed);
				color: var(--color-grey-9, #999);
				cursor: default;
			}
		}
	}

	.completion-box {
		border: 1px solid var(--color-grey-c, #e6e8ed);
		border-radius: 12px;
		padding: 32px;
		display: flex;
		align-items: flex-start;
		gap: 12px;

		&.mobile {
			padding: 20px 16px;
		}

		.completion-text {
			display: flex;
			flex-direction: column;
			gap: 6px;

			.main-msg {
				font-size: 15px;
				font-weight: 600;
				color: var(--color-black, #101010);
			}

			.sub-msg {
				font-size: 13px;
				color: var(--color-grey-6, #666);
			}
		}
	}

	.font-bold {
		font-weight: 700;
	}

	.success-toast {
		position: fixed;
		left: 48px;
		bottom: 48px;
		z-index: 1000;
		display: inline-flex;
		align-items: center;
		gap: 10px;
		background: #4d4d4d;
		color: #ffffff;
		border-radius: 12px;
		padding: 19px 24px;
		font-size: 18px;
		line-height: 26px;
		font-weight: 500;
		box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);
	}

	&.mobile .success-toast {
		left: 16px;
		bottom: 16px;
	}
`;
const ConsentDetail = ({ t }) => (react_1.default.createElement("div", { className: "consent-detail" },
    react_1.default.createElement("span", null,
        "\u2022 ",
        t('myAcademy.privacyProvider')),
    react_1.default.createElement("span", null,
        "\u2022 ",
        t('myAcademy.privacyPurpose')),
    react_1.default.createElement("span", null,
        "\u2022 ",
        t('myAcademy.privacyItems')),
    react_1.default.createElement("span", null,
        "\u2022 ",
        t('myAcademy.privacyPeriod')),
    react_1.default.createElement("span", null, t('myAcademy.privacyRefusal'))));
const ConsentBlock = ({ t, isChecked, onCheck, isAccordionOpen, onToggleAccordion, }) => (react_1.default.createElement("div", { className: "consent-section" },
    react_1.default.createElement("div", { className: "consent-row" },
        react_1.default.createElement(common_1.CheckBoxElement, { id: "privacy-consent", title: "myAcademy.privacyConsentRequired", checked: isChecked, handlerCheck: (_, checked) => onCheck(checked) }),
        react_1.default.createElement("button", { className: "btn-detail", onClick: onToggleAccordion },
            t('myAcademy.viewDetails'),
            react_1.default.createElement(common_1.Icon, { icon: "arrow", className: isAccordionOpen ? 'arrow-up' : 'arrow-down', size: 12 }))),
    isAccordionOpen && react_1.default.createElement(ConsentDetail, { t: t })));
const DSSMY001 = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isTablet } = (0, GlobalStateProvider_1.useGlobalState)();
    const userName = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserAuthName)(state));
    const userNickname = (0, react_redux_1.useSelector)((state) => (0, account_1.getUserNickname)(state));
    const classesTitle = (0, react_redux_1.useSelector)((state) => (0, classes_1.getClassesTitle)(state));
    const [academyStatus, setAcademyStatus] = (0, react_1.useState)('none');
    const [enrolledAcademy, setEnrolledAcademy] = (0, react_1.useState)(PLACEHOLDER_ACADEMY);
    const [isLoading, setIsLoading] = (0, react_1.useState)(true);
    const [selectedAcademy, setSelectedAcademy] = (0, react_1.useState)(PLACEHOLDER_ACADEMY);
    const [isConsented, setIsConsented] = (0, react_1.useState)(false);
    const [isAccordionOpen, setIsAccordionOpen] = (0, react_1.useState)(false);
    const [toastMessage, setToastMessage] = (0, react_1.useState)('');
    // 소속학원은 클래스 단위가 아니라 사용자/테넌트 단위 개념이라, 목록 조회를 현재 class_id로
    // 필터링하면 리스트가 비었음. 목록은 class_id 없이 조회(enroll 시에는 class_id 유지).
    const { data: academiesData, refetch: refetchAcademies } = (0, academy_1.useAcademiesList)({ limit: 100 });
    const academyList = react_1.default.useMemo(() => {
        if (!academiesData?.items)
            return [];
        return academiesData.items
            .filter((item) => !item.enrolled)
            .map((item) => ({
            id: item.academy_id,
            title: item.nickname,
        }));
    }, [academiesData]);
    react_1.default.useEffect(() => {
        refetchAcademies();
    }, []);
    react_1.default.useEffect(() => {
        if (!academiesData)
            return;
        const enrolledItem = academiesData.items?.find((item) => item.enrolled === true);
        if (enrolledItem) {
            setEnrolledAcademy({ id: enrolledItem.academy_id, title: enrolledItem.nickname });
            setAcademyStatus(enrolledItem.privacy_consent ? 'completed' : 'registered');
        }
        else {
            setAcademyStatus('none');
        }
        setIsLoading(false);
    }, [academiesData]);
    react_1.default.useEffect(() => {
        if (!toastMessage)
            return;
        const timer = window.setTimeout(() => {
            setToastMessage('');
        }, 2000);
        return () => window.clearTimeout(timer);
    }, [toastMessage]);
    const deviceClass = isMobile ? 'mobile' : isTablet ? 'tablet' : '';
    const academySelected = selectedAcademy.id !== 'select';
    const handleRegister = async () => {
        APP.eventManager.publish('SHOW_LOADING', true);
        try {
            await (0, academy_1.enrollAcademy)({
                academy_id: selectedAcademy.id,
                class_id: (0, classes_1.getClassesId)(),
            });
            setToastMessage(t('myAcademy.registerToast'));
            await refetchAcademies();
        }
        catch (error) {
            alert(error);
        }
        finally {
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    const handleConsent = async () => {
        APP.eventManager.publish('SHOW_LOADING', true);
        try {
            await (0, academy_1.enrollAcademy)({
                academy_id: enrolledAcademy.id,
                class_id: (0, classes_1.getClassesId)(),
            });
            setToastMessage(t('myAcademy.consentToast'));
            await refetchAcademies();
        }
        catch (error) {
            alert(error);
        }
        finally {
            APP.eventManager.publish('SHOW_LOADING', false);
        }
    };
    const displayedAcademy = enrolledAcademy.id !== 'select' ? enrolledAcademy.title : t('myAcademy.noAcademy');
    if (isLoading)
        return null;
    return (react_1.default.createElement(Wrap, { className: deviceClass },
        react_1.default.createElement("div", { className: "user-info" },
            react_1.default.createElement("div", { className: "user-name" },
                react_1.default.createElement(common_1.Icon, { icon: "user", size: 24 }),
                react_1.default.createElement("span", null, userNickname ? `${userNickname} (${userName})` : userName)),
            react_1.default.createElement("div", { className: "user-meta" },
                react_1.default.createElement("div", { className: "user-class" },
                    react_1.default.createElement("span", { className: "font-bold" }, t('myAcademy.currentClass')),
                    react_1.default.createElement("span", null, classesTitle ?? '-'),
                    react_1.default.createElement("span", { className: "divider" }, "|")),
                react_1.default.createElement("div", { className: "user-academy" },
                    react_1.default.createElement("span", { className: "font-bold" }, t('myAcademy.affiliatedAcademy')),
                    react_1.default.createElement("span", null, displayedAcademy)))),
        academyStatus === 'completed' ? (react_1.default.createElement("div", { className: `completion-box ${deviceClass}` },
            react_1.default.createElement(common_1.Icon, { icon: "info", size: 18 }),
            react_1.default.createElement("div", { className: "completion-text" },
                react_1.default.createElement("span", { className: "main-msg" }, t('myAcademy.completionMessage')),
                react_1.default.createElement("span", { className: "sub-msg" }, t('myAcademy.completionSubMessage'))))) : academyStatus === 'registered' ? (react_1.default.createElement("div", { className: `content-box ${deviceClass}` },
            react_1.default.createElement("div", { className: "form-section" },
                react_1.default.createElement("span", { className: "section-label" }, t('myAcademy.selectAcademy')),
                react_1.default.createElement("span", null, enrolledAcademy.title)),
            react_1.default.createElement("p", { className: "guide-text" }, t('myAcademy.privacyConsentGuide')),
            react_1.default.createElement("div", { className: "consent-section" },
                react_1.default.createElement("span", { className: "section-label" }, t('myAcademy.privacyConsent')),
                react_1.default.createElement(ConsentBlock, { t: t, isChecked: isConsented, onCheck: setIsConsented, isAccordionOpen: isAccordionOpen, onToggleAccordion: () => setIsAccordionOpen((v) => !v) })),
            react_1.default.createElement("div", { className: "btn-area" },
                react_1.default.createElement(common_1.Button, { className: `btn-consent ${isConsented ? 'active' : ''}`, text: "myAcademy.consent", onClick: isConsented ? handleConsent : undefined })))) : (react_1.default.createElement("div", { className: `content-box ${deviceClass}` },
            react_1.default.createElement("div", { className: "guide-section" },
                react_1.default.createElement("p", { className: "info-icon" }, "\u24D8"),
                react_1.default.createElement("p", { className: "guide-text" }, t('myAcademy.registrationGuide'))),
            react_1.default.createElement("div", { className: "form-section" },
                react_1.default.createElement("span", { className: "section-label" }, t('myAcademy.selectAcademy')),
                react_1.default.createElement(common_1.DropDown, { className: "dropdown-popup", value: selectedAcademy, list: academyList, setDropValue: (item) => setSelectedAcademy(item), styles: {
                        dropWrap: { width: isMobile ? '100%' : 240 },
                        itemWrap: { maxHeight: 200 },
                    } }),
                react_1.default.createElement("span", { className: "section-guide" }, t('myAcademy.selectAcademyGuide'))),
            react_1.default.createElement("div", { className: "consent-section" },
                react_1.default.createElement("span", { className: "section-label" }, t('myAcademy.privacyConsent')),
                react_1.default.createElement(ConsentBlock, { t: t, isChecked: isConsented, onCheck: setIsConsented, isAccordionOpen: isAccordionOpen, onToggleAccordion: () => setIsAccordionOpen((v) => !v) })),
            react_1.default.createElement("div", { className: "btn-area" },
                react_1.default.createElement(common_1.Button, { className: `btn-register ${academySelected && isConsented ? 'active' : ''}`, text: "myAcademy.register", onClick: academySelected && isConsented ? handleRegister : undefined })))),
        toastMessage && (react_1.default.createElement("div", { className: "success-toast" },
            react_1.default.createElement(common_1.Icon, { icon: "check-circle", size: 22, fill: "#8f7bff" }),
            toastMessage))));
};
exports.DSSMY001 = DSSMY001;
